import { Tag } from '@humanforce/mango-ui-react';
import type { PersonStatus } from '../workersApiTypes';

/** Status pill for a Person/Worker. Active = positive (green), Terminated = neutral grey. */
export const WorkerStatusTag = ({ status }: { status: PersonStatus }) => (
  <Tag label={status === 'active' ? 'Active' : 'Terminated'} tone={status === 'active' ? 'positive' : 'neutral'} weight="strong" />
);
